<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <button
                    class="btn btn-primary"
                    @click="printForm"
                >
                    <i class="fa fa-print" /> Print
                </button>
                <router-link
                    :to="{name: 'office.forms.edit', params: { id: id }}"
                    class="btn btn-info"
                    v-if="$route.name === 'Preview Form'"
                >
                    <i class="fa fa-pencil-alt" /> Edit
                </router-link>
                <router-link
                    :to="{name: 'engineer.forms.edit', params: { id: id }}"
                    class="btn btn-info"
                    v-if="$route.name === 'Engineer Preview Form'"
                >
                    <i class="fa fa-pencil-alt" /> Edit
                </router-link>
            </div>
        </div>
        <iframe
            v-if="previewUrl"
            :src="previewUrl"
            frameborder="0"
            id="preview_frame"
            name="preview_frame"
            class="form-preview-frame"
        />
    </div>
</template>

<script>
import FormService from "../../services/FormService";

export default {
    data: function() {
        return {
            previewHtml: null,
            previewUrl: null,
            id: null,
        }
    },
    mounted: function() {
        this.id = this.$route.params.id;
        this.loadPreview(this.$route.params.id);
        this.previewUrl = '/api/forms/'+this.$route.params.id+'/preview';
    },
    methods: {
        loadPreview: function(id) {
            FormService.preview(id).then(res => {
                this.previewHtml = res.data;
            }, err => {
                this.setErrorMessage('Could not load form');
                console.error(err);
            });
        },

        printForm: function () {
            window.frames["preview_frame"].focus();
            window.frames["preview_frame"].print();
        }
    },
}
</script>




// WEBPACK FOOTER //
// resources/assets/js/components/forms/PreviewComponent.vue